export default __webpack_public_path__ + "static/media/lego.ac4aae419549ce9e9c2d7a79b82d8f5d.svg";